export function getExpiryDate(value) {
  return `${value[0]}${value[1]}/${value[2]}${value[3]}`
}
